<section class="client-card">
  <h3 class="client-card__title">Assinaturas</h3>

  @if (state() === 'none') {
    <p class="signatures__empty">
      A Legatus ainda não enviou documentos para a sua assinatura. Quando enviar, eles aparecem
      aqui.
    </p>
  } @else {
    <div class="signatures__row">
      <div class="signatures__doc">
        <i class="pi pi-file-edit" aria-hidden="true"></i>
        <div>
          <strong>NDA de confidencialidade + Carta de Autorização SCR (Banco Central)</strong>
          @if (term()?.requestedAt; as requestedAt) {
            <span>Enviado para assinatura em {{ requestedAt | vaultDateTime }}</span>
          }
        </div>
      </div>

      @switch (state()) {
        @case ('signed') {
          <span class="signatures__tag signatures__tag--success">
            assinado em {{ term()?.signedAt ?? null | vaultDateTime }}
          </span>
        }
        @case ('canSign') {
          <app-button
            label="Assinar agora"
            icon="pi pi-pencil"
            theme="darkblue"
            size="small"
            [isLoading]="signing()"
            [loadingText]="'Abrindo...'"
            [disabled]="signing()"
            [type]="'button'"
            (sendButtonClick)="sign.emit()" />
        }
        @case ('waiting') {
          <span class="signatures__tag signatures__tag--warning">aguardando assinaturas</span>
        }
        @case ('notSent') {
          <span class="signatures__tag">ainda não enviado</span>
        }
        @case ('cancelled') {
          <span class="signatures__tag">envio cancelado</span>
        }
      }
    </div>

    @if (signatories().length) {
      <ul class="signatures__people" aria-label="Assinantes">
        @for (signatory of signatories(); track $index) {
          <li>
            <span>
              {{ signatory.name }}
              @if (signatory.isCurrentUser) {
                <em>(você)</em>
              }
            </span>
            @if (signatory.signedAt) {
              <span class="signatures__done"
                >assinou em {{ signatory.signedAt | vaultDateTime }}</span
              >
            } @else {
              <span class="signatures__pending">ainda não assinou</span>
            }
          </li>
        }
      </ul>
    }

    @if (state() === 'waiting') {
      <p class="signatures__hint">
        Falta a assinatura de outra pessoa da sua empresa. Cada assinante recebe o próprio link.
      </p>
    }
    @if (state() === 'cancelled') {
      <p class="signatures__hint">
        O envio foi cancelado. Se você ainda precisa assinar, fale com o time da Legatus.
      </p>
    }

    @if (signLinkOpened() && state() === 'canSign') {
      <div class="signatures__after-sign">
        <p>Assinou na outra aba? Clique em Atualizar para ver o status aqui.</p>
        <app-button
          label="Atualizar"
          icon="pi pi-refresh"
          theme="outline-grey"
          size="small"
          [type]="'button'"
          (sendButtonClick)="refresh.emit()" />
      </div>
    }
  }

  <p class="signatures__note">
    A autorização SCR permite à Legatus consultar o histórico de crédito da sua empresa no Banco
    Central. É uma exigência regulatória e pode ser revogada a qualquer momento.
  </p>
</section>
